import React from 'react';
import { I18n as I } from 'react-redux-i18n';

import PropTypes from 'prop-types';

import Portlet from '../layout/Portlet';
import { isNil } from 'vdlib';

class AuctionInsuranceData extends React.Component {
  render() {
    if (isNil(this.props.data)) return false;

    return (
      <Portlet
        title={`${
          I.t('INSURANCE_C') + ': ' + this.props.data.DistinctiveTitle
        }`}
        className="col-md-12"
        titleColorClass="font-purple-plum"
      >
        <div className="row static-info">
          <div className="col-md-4 name"> {I.t('TAXNUMBER')}: </div>
          <div className="col-md-8 value"> {this.props.data.AFM || '-'} </div>
        </div>
        <div className="row static-info">
          <div className="col-md-4 name"> {I.t('ADDRESS')}: </div>
          <div className="col-md-8 value">
            {' '}
            {`${this.props.data.Address || '-'} `}{' '}
          </div>
        </div>
        <div className="row static-info">
          <div className="col-md-4 name"> {I.t('PHONE_SHORT')}: </div>
          <div className="col-md-8 value">
            {' '}
            {`${this.props.data.Phone || '-'} `}{' '}
          </div>
        </div>
        <div className="row static-info">
          <div className="col-md-4 name"> {I.t('FAX')}: </div>
          <div className="col-md-8 value">
            {' '}
            {`${this.props.data.Fax || '-'} `}{' '}
          </div>
        </div>
        <div className="row static-info">
          <div className="col-md-4 name"> {I.t('MOBILE')}: </div>
          <div className="col-md-8 value">
            {' '}
            {`${this.props.data.Mobile || '-'} `}{' '}
          </div>
        </div>
      </Portlet>
    );
  }
}

AuctionInsuranceData.propTypes = {
  data: PropTypes.object,
};

export default AuctionInsuranceData;
